<template>
  <!-- ========================= 顶部导航栏 ========================= -->
  <div id="header">
    <div class="container header_box">
      <!-- logo -->
      <h1><a class="logo" href="http://hmmwuliu.net/index.html" title="货满满物流">货满满物流</a></h1>
      <!-- nav goUrl('/statusquo') -->
      <ul class="nav">
        <li @click="goHome">
          <span :class="{activeColor: pagePath === '/statusquo'}">首页</span>
          <div class="bor" :class="{border_line: pagePath === '/statusquo'}"></div>
        </li>
        <li @click="goUrl('/')">
          <span :class="{activeColor: pagePath === '/'}">关于我们</span>
          <div class="bor" :class="{border_line: pagePath === '/'}"></div>
        </li>
        <li class="sever_list" @click="goUrl('/serve')">
          <span :class="{activeColor: pagePath.indexOf('/serve') !== -1}">产品与服务</span>
          <div class="bor" :class="{border_line: pagePath.indexOf('/serve') !== -1}"></div>
          <ul class="nav_more">
            <li :class="{activeColor: pagePath === '/serve-serveshipper'}" @click.stop="goUrl('/serve-serveshipper')">货主发货</li>
            <li :class="{activeColor: pagePath === '/serve-servedriver'}" @click.stop="goUrl('/serve-servedriver')">司机接单</li>
            <li :class="{activeColor: pagePath === '/serve-download'}" @click.stop="goUrl('/serve-download')">产品下载</li>
          </ul>
        </li>
        <li @click="goUrl('/newslist')">
          <span :class="{activeColor: pagePath.indexOf('news') !== -1}">新闻中心</span>
          <div class="bor" :class="{border_line: pagePath.indexOf('news') !== -1}"></div>
        </li>
        <li @click="goUrl('/business')">
          <span :class="{activeColor: pagePath === '/business'}">业务合作</span>
          <div class="bor" :class="{border_line: pagePath === '/business'}"></div>
        </li>
        <li>
          <span class="tel">4001-368-360</span>
          <span class="tel_btn">咨询电话</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return{
      pagePath: '/',
    }
  },
  created() {
    this.pagePath = this.$route.path
  },
  methods: {
    /**
     * @description: 跳转路径
     * @author: 书童
     */
    goUrl(url) {
      this.$router.push({
        path: url
      })
    },
    /**
     * @description: 跳转首页
     * @author: 书童
     */
    goHome() {
      window.location.href = 'http://hmmwuliu.net/index.html'
    }
  },
}
</script>

<style lang="scss" scoped>
.container{
  width: 1200px;
  margin: 0 auto;
}
#header{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100px;
  z-index: 99;
  background-color: #fff;
}
.header_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}
.header_box .logo{
  display: block;
  height: 100px;
  width: 100px;
  background: url(https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/logo.png);
  background-size: 100px 100px;
  text-indent: -999px;
  overflow: hidden;
}
.header_box > ul{
  display: flex;
  justify-content: flex-end;
  height: 100%;
}
.header_box > ul li {
  position: relative;
  height: 100%;
  margin: 0 30px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 100px;
  cursor: pointer;
  .bor{
    width: 0px;
  }
}
.header_box > ul > li .border_line{
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 4px;
  background-color: #4E9BFF;
  transition: border 2s;
}
.header_box > ul > li .tel{
  font-size: 26px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #333333;
  line-height: 100px;
}
.header_box > ul > li .tel_btn{
  float: right;
  width: 100px;
  height: 35px;
  background: #4e9bff;
  border-radius: 4px;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 32px;
}
.header_box > ul > li > .nav_more{
  display: none;
  position: absolute;
  left: -30px;
  bottom: -160px;
  display: none;
  background-color: #ffffff;
  width: 150px;
  height: 160px;
}
.header_box > ul > li > .nav_more > li {
  height: 50px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 50px;
}
.header_box > ul > li > .nav_more > li:hover{
  color: #4e9bff;
}
.header_box > ul li:hover .nav_more{
  display: block;
}
.activeColor{
  color: #4E9BFF!important;
}
.header_box > ul li:hover{
  color: #4E9BFF;
  .bor{
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 4px;
    background-color: #4E9BFF;
    transition: width 0.4s;
  }
}
</style>